import { atomEffect } from "jotai-effect";

import { formAtom } from "@frontend/lib/form";

import { defaultLocationFormData, locationSchema } from "../schemas/location";
import { locationModalAtom } from "./state";
import { contactIdAtom, isVisibleAtom } from "./visibility";

export const locationForm = formAtom(locationSchema, defaultLocationFormData);

// Reset the form and pre-fill the contact every time the modal is opened
// (not just when the contactId value differs — reopening with the same
// contact must still start from a blank form).
//
// Depends on the narrow `isVisibleAtom`/`contactIdAtom` reads, NOT the raw
// `locationModalAtom` — that atom also holds `autoName`/`newAddress` UI
// toggles (see stores/ui.ts), and reading it here would re-run this effect
// (and reset everything) on every checkbox click.
export const locationFormSyncEffect = atomEffect((get, set) => {
  const isVisible = get(isVisibleAtom);
  const contactId = get(contactIdAtom);

  if (isVisible) {
    set(locationForm.actions.setInitial, {
      ...defaultLocationFormData,
      contactId,
    });

    set(locationModalAtom, (draft) => {
      draft.autoName = true;
      draft.newAddress.toggle = false;
      draft.newAddress.autoPostalCode = true;
    });
  }
});
